import React from 'react'
import Upload from '../../components/UploadComponet/Upload'

const Uploadpage = () => {
  return (
    <div>
      <Upload />
    </div>
  )
}

export default Uploadpage